import { useState } from "react";
import AuthScreen from "../../components/AuthScreen"
import { requestOTPHandler, signInHandler } from "../../utils/authHelpers";
import { useGlobalContext } from "../../context/GlobalContext";
import { useToastContext } from "../../context/ToastContext";
import { errorHandler, localStorageHandler } from "../../utils/helpers";
import { CONSTANTS } from "../../constants/Constants";
import { useNavigate } from "react-router-dom";

const SignUp = () => {
    const { setUser, setShowHeader, isLoading, setIsLoading } = useGlobalContext()
    const { showToast } = useToastContext()
    const [otp, setOTP] = useState<string>("");
    const [showOtpScreen, setShowOtpScreen] = useState(false);
    const [signUpPayload, setSignUpPayload] = useState<{
        email: string;
        companyName: string;
        method: string;
    }>({
        email: "",
        companyName: "",
        method: "Signup",
    });
    const navigate = useNavigate();

    const changeHandler = (e: Event) => {
        const target = e.target as HTMLInputElement;
        setSignUpPayload({ ...signUpPayload, [target.name]: target.value });
    };

    const submitHandler = async () => {
        if (signUpPayload.companyName !== "" || signUpPayload.email !== "") {
            setIsLoading(true)
            let res = await requestOTPHandler(
                signUpPayload.email,
                signUpPayload.method,
                signUpPayload.companyName
            );
            if (res.status === 200) {
                setShowOtpScreen(true);
                setShowHeader(true)
            } else {
                setShowOtpScreen(false);
                setShowHeader(false)
                let error = await errorHandler(res);
                showToast(error, "error");
            }
            setIsLoading(false)
        } else {
            showToast("Email or Company Name can not be empty", "error");
        }
    };

    const otpChangeHandler = (otp: string) => {
        setOTP(otp);
    };

    const verifyAndRegister = async () => {
        try {
            setIsLoading(true)
          let res = await signInHandler(otp, "Registration");
          if (res.status === 200) {
            const userData = res.data.data;
            showToast(res?.data?.message, "success");
            localStorageHandler(
              "set",
              CONSTANTS.LOCAL_STORAGE_KEYS.USER_TOKEN_TXT,
              userData.token
            );
            localStorageHandler(
              "set",
              CONSTANTS.LOCAL_STORAGE_KEYS.USER_TXT,
              userData
            );
    
            setUser(userData);
    
            navigate("/dashboard-setup");
            setIsLoading(false);
          } else {
            setShowOtpScreen(false);
            setShowHeader(false)
            let error = await errorHandler(res);
            showToast(error, "error");
          }
        } catch (error) { }
      };

    return (
        <AuthScreen
            isLoading={isLoading}
            email={signUpPayload.email}
            showOTPScreen={showOtpScreen}
            changeHandler={changeHandler}
            otpRequest={submitHandler}
            otpChangeHandler={otpChangeHandler}
            companyName={signUpPayload.companyName}
            authError=""
            isDisable={isLoading}
            isLoginScreen={false}
            verifyOTPAndLogin={verifyAndRegister}
        />
    )
}

export default SignUp